
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.016 1C5.036 1 1 4.74 1 9.357c0 1.914.701 3.666 1.863 5.07-.524 1.588-1.615 2.929-1.633 2.944a1.072 1.072 0 00-.163 1.044c.137.352.438.585.777.585 2.166 0 3.843-1.035 4.9-1.858.985.363 2.12.572 3.27.572 4.98 0 8.985-3.742 8.985-8.357C19 4.742 14.996 1 10.016 1zm.003 14.786c-.942 0-1.87-.166-2.76-.487l-.801-.287-.687.553a7.238 7.238 0 01-2.025 1.165c.26-.487.506-1.035.7-1.617l.374-1.125-.726-.879c-.635-.775-1.401-2.056-1.401-3.752 0-3.546 3.284-6.428 7.325-6.428 4.042 0 7.326 2.882 7.326 6.428s-3.285 6.429-7.325 6.429z","fill":"#000","stroke":"#000","stroke-width":".5"}}),_c('path',{attrs:{"d":"M5.142 8.712a.364.364 0 000 .576l3.08 2.593a.55.55 0 00.683 0 .364.364 0 000-.576L6.168 9l2.737-2.305a.364.364 0 000-.576.55.55 0 00-.684 0l-3.08 2.593zM14 8.592H5.484v.815H14v-.814z","fill":"#000","stroke":"#000","stroke-width":".5"}})])
          )
        }
      }
    